import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from "@angular/material/toolbar";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BackendInterceptor } from './backend.interceptor';
import { LoginDialogComponent } from './views';
import { LandingComponent } from './views/landing/landing.component';
import { GhaMask4Component } from './views/gha-mask4/gha-mask4.component';
import { Mask4Component } from './views/mask4/mask4.component';
import { ScanDialogComponent } from './views/scan-dialog/scan-dialog.component';
import { TimeTravelDialogComponent } from './views/time-travel-dialog/time-travel-dialog.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DisplayValueComponent } from './views/display-value/display-value.component';
import { ForwarderMask1Component } from './views/forwarder-mask1/forwarder-mask1.component';
import { DisplayMultiLineComponent } from './views/display-multi-line/display-multi-line.component';
import { PiecesTableComponent } from './views/pieces-table/pieces-table.component';
import { ChaMask2Component } from './views/cha-mask2/cha-mask2.component';
import { ChaForwarderMask3Component } from './views/cha-forwarder-mask3/cha-forwarder-mask3.component';
import { HiddenMenuComponent } from './views/hidden-menu/hidden-menu.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginDialogComponent,
    LandingComponent,
    GhaMask4Component,
    Mask4Component,
    ScanDialogComponent,
    TimeTravelDialogComponent,
    DisplayValueComponent,
    ForwarderMask1Component,
    DisplayMultiLineComponent,
    PiecesTableComponent,
    ChaMask2Component,
    ChaForwarderMask3Component,
    HiddenMenuComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTableModule,
    MatToolbarModule,
    FlexLayoutModule,
    NgxScannerQrcodeModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    ReactiveFormsModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: BackendInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
